import { render, staticRenderFns } from "./bi-event-item.vue?vue&type=template&id=0d4f55ed&"
import script from "./bi-event-item.vue?vue&type=script&lang=ts&"
export * from "./bi-event-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports